import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@mui/material';
import { Payment } from '@mui/icons-material';
import { addTab } from '../../tabs/tabsSlice';
import MainText from '../../components/MainText';
import PaymentStepper from '../../components/PaymentStepper';

function CreatePayment() {
  const initialDraft = useMemo(
    () => ({
      supplier: {
        id: 0,
        name: '',
        bankAccounts: [],
        earlyPayments: [],
      },
      invoices: {
        available: [],
        selectedIds: [],
        detailsByInvoice: {},
        scope: 'payable',
        hasMore: false,
        serverOffset: 0,
        paginationModel: { page: 0, pageSize: 10 },
      },
      documents: {
        paymentDocs: [],
        creditNotes: [],
        receipts: [],
      },
      allocations: {},
      adjustments: {
        manualAdjustments: [],
        suggestionSelections: {},
        earlyPaymentStateByKey: {},
        billUsages: {},
        creditOnlyHasReceipt: false,
        settlementComment: '',
      },
      metadata: {
        activeStep: 0,
        summaryUiState: {
          activeInvoiceId: null,
          detailQuery: '',
          detailStatus: 'all',
          detailPage: 0,
          detailPageSize: 25,
        },
      },
    }),
    []
  );

  const [paymentDraft, setPaymentDraft] = useState(initialDraft);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addTab({ label: 'Pagar factura', path: '/payment/make-payment/' }));
  }, [dispatch]);

  return (
    <>
      <MainText
        title={'Pago de factura'}
        subtitle={'Ingrese los datos de la factura a pagar'}
        icon={Payment}
      />
      <Box
        sx={{
          maxWidth: '100%',
          overflowX: 'hidden',
        }}
      >
        <PaymentStepper draft={paymentDraft} setDraft={setPaymentDraft} />
      </Box>
    </>
  );
}

export default CreatePayment;
